import { BaseService } from "./BaseService";

export const UnidadePrimariaService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elementos-primarios/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidades primárias:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('elementos-primarios/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidades primárias:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`elementos-primarios/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca da unidade primária:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`elementos-primarios/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização da unidade primária:', error);
            return false;
        }
    },
}